import './Separator.scss';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Separator(props: {showArrow?: boolean, isInvisible?: boolean}) {
    return <div className={`separator-wrapper ${props.showArrow ? '-arrow' : ''}
         ${props.isInvisible ? '-visibility-hidden' : ''}`}>
        
        <hr className='separator'/>
        {props.showArrow ? <FontAwesomeIcon className="icon" icon={faCaretDown}/> : null}
    </div>;
};